/**
 * Guard por **rol**: shell revisor (`/reviewer/**`). Delega en {@link AuthService.checkRolePermission}
 * con {@link UserRole.reviewer}.
 *
 * @see AuthService
 */

import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { AuthService } from '../../features/auth/services/auth.service';
import { UserRole } from '../models/auth.model';

export const isReviewerGuard: CanActivateFn = async () => {
  const authService = inject(AuthService);

  return await authService.checkRolePermission(UserRole.reviewer);
};
